import { render, staticRenderFns } from "./ReceptionSurveillancePdf.vue?vue&type=template&id=bf1b45ee"
import script from "./ReceptionSurveillancePdf.vue?vue&type=script&lang=js"
export * from "./ReceptionSurveillancePdf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports